import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	// The following messages were copied from src/main/resources/cmdb-legacy-ui/js/i18n.js in the Jira monolith.
	// They are being progressively added or removed usages are fully tracked down in following PR's.

	// externalImport: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.external-import',
	//     defaultMessage: 'External Import',
	//     description: 'Refers to importing data from an external system',
	// },
	// importDataFromAnExternalApp: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-data-from-an-external-app',
	//     defaultMessage: 'Import data from an external app into Assets',
	//     description: 'Refers to importing data from an external app into the Assets product',
	// },
	// importModuleExternalName: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-external-name',
	//     defaultMessage: 'External Import',
	//     description: '',
	// },
	// importModuleExternalDescription: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-external-description',
	//     defaultMessage: 'Import data from an external app into Insight',
	//     description: '',
	// },
	// importModuleCsvName: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-csv-name',
	//     defaultMessage: 'CSV Import',
	//     description: '',
	// },
	// importModuleCsvDescription: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-csv-description',
	//     defaultMessage: 'Import a CSV file into Insight',
	//     description: '',
	// },
	// importModuleDiscoveryName: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-discovery-name',
	//     defaultMessage: 'Discovery Import',
	//     description: '',
	// },
	// importModuleDiscoveryDescription: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-discovery-description',
	//     defaultMessage: 'Import discovery data into Insight',
	//     description: '',
	// },
	// importModuleJsonName: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-json-name',
	//     defaultMessage: 'JSON Import',
	//     description: '',
	// },
	// importModuleJsonDescription: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-json-description',
	//     defaultMessage: 'Import a JSON file into Insight',
	//     description: '',
	// },
	// importFileName: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-file-name',
	//     defaultMessage: 'File',
	//     description: '',
	// },
	// importFileNameDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-file-name-desc',
	//     defaultMessage: 'Select a file to import.',
	//     description: '',
	// },
	// importDelimiter: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-delimiter',
	//     defaultMessage: 'Delimiter',
	//     description: '',
	// },
	// importDelimiterDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-delimiter-desc',
	//     defaultMessage:
	//         'The delimiter used in the file. One character is allowed except for "Tab" where you would enter \\t',
	//     description: '',
	// },
	// importEncoding: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-encoding',
	//     defaultMessage: 'Encoding',
	//     description: '',
	// },
	// importEncodingDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-encoding-desc',
	//     defaultMessage: 'The encoding used in the file.',
	//     description: '',
	// },
	// configInfoName: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.config-info-name',
	//     defaultMessage: 'Name',
	//     description: '',
	// },
	// importNameDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-name-desc',
	//     defaultMessage: 'The name for the configuration',
	//     description: '',
	// },
	// importValidationNameDuplicate: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-validation-name-duplicate',
	//     defaultMessage: 'There is already an import configuration with this name',
	//     description: '',
	// },
	// rlabsInsightHeaderDescription: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.rlabs-insight-header-description',
	//     defaultMessage: 'Description',
	//     description: '',
	// },
	// importDescriptionDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-description-desc',
	//     defaultMessage: 'The description for the configuration',
	//     description: '',
	// },
	// importConcatinator: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-concatinator',
	//     defaultMessage: 'Concatenator',
	//     description: '',
	// },
	// importConcatinatorDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-concatinator-desc',
	//     defaultMessage:
	//         'When joining multiple data locators into one Insight attribute, this will be the default concatenator. Enter \\s for space-concatenated.',
	//     description: '',
	// },
	// importRemove: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-remove',
	//     defaultMessage: 'Remove',
	//     description: '',
	// },
	// importIgnore: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-ignore',
	//     defaultMessage: 'Ignore',
	//     description: '',
	// },
	// importAdd: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-add',
	//     defaultMessage: 'Add',
	//     description: '',
	// },
	// importDatalocatorEmptyvalue: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datalocator-emptyvalue',
	//     defaultMessage: 'Empty Values',
	//     description: '',
	// },
	// importDatalocatorEmptyvalueDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datalocator-emptyvalue-desc',
	//     defaultMessage: 'Specify if the import should remove or ignore empty values',
	//     description: '',
	// },
	// importDatalocatorUnknownvalue: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datalocator-unknownvalue',
	//     defaultMessage: 'Unknown Values',
	//     description: '',
	// },
	// importDatalocatorUnknownvalueDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datalocator-unknownvalue-desc',
	//     defaultMessage:
	//         'Specify if the import should try to add unknown values to Insight configuration or just ignore them. This is applied on Status and Select attribute types.',
	//     description: '',
	// },
	// importDateformat: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-dateformat',
	//     defaultMessage: 'Date Format',
	//     description: '',
	// },
	// importDateformatDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-dateformat-desc',
	//     defaultMessage:
	//         'Optional date format to convert dates into Insight. Insight will automatically try to find correct format if no one provided.',
	//     description: '',
	// },
	// importDatetimeformat: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datetimeformat',
	//     defaultMessage: 'Date/Time Format',
	//     description: '',
	// },
	// importDatetimeformatDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datetimeformat-desc',
	//     defaultMessage:
	//         'The date/time format to convert dates with time into Insight. Insight will automatically try to find correct format if no one provided',
	//     description: '',
	// },
	constraintViolationReferenceTypeBeanSizeName: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-reference-type-bean-size-name',
		defaultMessage: 'Name must contain at least 2 and max 30 characters',
		description: '',
	},
	constraintViolationStatusTypeBeanNotNullName: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-status-type-bean-not-null-name',
		defaultMessage: 'Name has to be entered',
		description: '',
	},
	constraintViolationStatusTypeBeanSizeName: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-status-type-bean-size-name',
		defaultMessage: 'Name must contain at least 2 and max 30 characters',
		description: '',
	},
	constraintViolationStatusTypeBeanSizeDescription: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-status-type-bean-size-description',
		defaultMessage: 'Description must contain max 255 characters',
		description: '',
	},
	constraintViolationStatusTypeBeanUsed: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-status-type-bean-used',
		defaultMessage: "Can't delete status type since it's used by one or more object types.",
		description: '',
	},
	// importModuleValidationInvalidFile: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-validation-invalid-file',
	//     defaultMessage: 'Invalid file!',
	//     description: '',
	// },
	// importValidationObjecttypeattributeRequired: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-validation-objecttypeattribute-required',
	//     defaultMessage: 'The mapping to an Insight Object Types attribute is required.',
	//     description: '',
	// },
	constraintViolationObjectSchemaBeanSizeName: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-object-schema-bean-size-name',
		defaultMessage: 'Name must contain at least 2 and max 50 characters',
		description: '',
	},
	constraintViolationObjectTypeBeanSizeName: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-object-type-bean-size-name',
		defaultMessage: 'Name must contain at least 2 and max 50 characters',
		description: '',
	},
	constraintViolationObjectTypeBeanSizeDescription: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-object-type-bean-size-description',
		defaultMessage: 'Description must contain max 70 characters',
		description: '',
	},
	constraintViolationObjectSchemaBeanSizeDescription: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-object-schema-bean-size-description',
		defaultMessage: 'Description must contain max 80 characters',
		description: '',
	},
	// userPickerAjaxDesc: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.user-picker-ajax-desc',
	//     defaultMessage: 'Start typing to get a list of possible matches.',
	//     description: '',
	// },
	// objectschemaImportAnalyzeFailed: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed',
	//     defaultMessage: 'Failed to analyze the specified file!',
	//     description: '',
	// },
	// objectschemaImportAnalyzeFailedCompression: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed-compression',
	//     defaultMessage: 'Unknown file compression!',
	//     description: '',
	// },
	// objectschemaImportAnalyzeFailedChecksum: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed-checksum',
	//     defaultMessage: 'File integrity violation',
	//     description: '',
	// },
	// objectschemaImportAnalyzeFailedArchive: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed-archive',
	//     defaultMessage: 'File archive error',
	//     description: '',
	// },
	// objectschemaImportAnalyzeFailedArchiveContentInvalid: {
	//     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed-archive-content-invalid',
	//     defaultMessage: 'Invalid file content',
	//     description: '',
	// },
	constraintViolationVariablesEntrySizeName: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-variables-entry-size-name',
		defaultMessage: 'Name must contain at least 2 and max 50 characters',
		description: '',
	},
	constraintViolationVariablesEntryPatternObjectSchemaKey: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-variables-entry-pattern-object-schema-key',
		defaultMessage:
			'Key must contain only alphabetic letters and digits and be 2-10 characters long.',
		description: '',
	},
	constraintViolationVariablesEntrySizeDescription: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-variables-entry-size-description',
		defaultMessage: 'Description must contain max 80 characters',
		description: '',
	},
	errorDuplicateName: {
		id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.error-duplicate-name',
		defaultMessage: 'There is already an import configuration with this name',
		description: 'Error text to show when the import configuration name is duplicated',
	},
});
